// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"df27387e","936":"4422e0bb"}[chunkId] + ".chunk.js";
};